import apiService from '../../services/ApiService';
import appParameters from '../../components/utils/AppParameters';
import dataLoader from '../../DataLoader';
import configuration from '../../constants/Configuration';

const sessionUtils = {
    parametersLoaded: false,

    doLogin(token, id) {
        var self = this;

        apiService.doLoginWithToken(token, id)
            .then(response => {
                return self.decodeResponse(response);
            });
    },
    decodeResponse(response) {
        if (!response)
            return;

        this.parametersLoaded = true;

        var exercise,
            content,
            assignment,
            title,
            description,
            clipartReference,
            thumbUrl,
            assignmentFolderId,
            assignmentSubmitId,
            exerciseId,
            contentItemId,
            languageId,
            navBarTitle,
            thumbnailId,
            assignmentStatus;

        if (response.languageId)
            languageId = response.languageId;

        if (response.assignmentId)
            assignmentFolderId = response.assignmentId;

        if (response.assignmentSubmitId)
            assignmentSubmitId = response.assignmentSubmitId;

        if (response.exercise)
            exercise = response.exercise;

        if (response.content)
            content = response.content;

        if (response.assignment)
            assignment = response.assignment;

        if (response.status)
            assignmentStatus = response.status.toUpperCase();

        if (exercise) {
            if (exercise.title)
                title = exercise.title;

            if (exercise.title)
                navBarTitle = exercise.title;

            if (exercise.description)
                description = this.correctDescription(exercise.description);

            if (exercise.clipartReference)
                clipartReference = exercise.clipartReference;

            if (exercise.thumbUrl)
                thumbUrl = exercise.thumbUrl;

            if (exercise.exerciseId)
                exerciseId = exercise.exerciseId;

            if (exercise.contentId)
                contentItemId = exercise.contentId;

            if (exercise.thumbnailId)
                thumbnailId = exercise.thumbnailId;
        }

        if (content) {
            if (content.contentItemId)
                contentItemId = content.contentItemId;

            if (content.title)
                title = content.title;

            if (!description && content.description)
                description = this.correctDescription(content.description);

            if (content.clipartReference)
                clipartReference = content.clipartReference;

            if (!thumbUrl && content.thumbUrl)
                thumbUrl = content.thumbUrl;
        }

        if (assignment) {
            if (assignment.title)
                title = assignment.title;

            if (assignment.description)
                description = this.correctDescription(assignment.description);

            if (assignment.thumbUrl)
                thumbUrl = assignment.thumbUrl;

            if (!exerciseId) {
                contentItemId = this.checkThumbUrl(thumbUrl);
            }

            exerciseId = -1;
        }

        appParameters.locale = this.detectLanguage(languageId);
        appParameters.title = title;
        appParameters.navBarDescription = description;
        appParameters.assignmentStatus = assignmentStatus;

        var clipartMap = this.getClipartOldMap();

        if (clipartMap[clipartReference] > 0)
            clipartReference = clipartMap[clipartReference];

        if (appParameters.isMaster)
            contentItemId = -1;

        if (appParameters.isExercise && exercise) {
            if (exercise.hasContent == true) {
                // keep the contentItemId ... the exercise has already content.
            } else
                contentItemId = -1;
        }

        if (appParameters.isMaster || clipartReference == configuration.MASTER_CLIPART_ID_PROD || clipartReference == 62315556 || contentItemId == 62344225) {
            if (appParameters.locale == 'sv_SE')
                clipartReference = 70622606; // Sweden universe
            else
                clipartReference = configuration.DEFAULT_CLIPART_ID_PROD;
        }

        appParameters.clipartId = clipartReference;

        if (!navBarTitle)
            appParameters.navBarTitle = title;
        else
            appParameters.navBarTitle = navBarTitle;

        if (!thumbnailId)
            appParameters.navBarThumbnailId = contentItemId;
        else
            appParameters.navBarThumbnailId = thumbnailId;

        if (exerciseId)
            appParameters.exerciseId = exerciseId;

        if (contentItemId)
            appParameters.contentItemId = contentItemId;

        if (assignmentSubmitId)
            appParameters.submitId = assignmentSubmitId;

        if (assignmentFolderId)
            appParameters.assignmentFolderId = assignmentFolderId;

        if (appParameters.isAudioToken)
            appParameters.context = 'audioTool';
        else
            appParameters.context = 'edit';

        appParameters.token = '';

        dataLoader.loadData();
    },
    getClipartOldMap() {
        var map = [];

        map[865484] = 64097358;
        map[864117] = 64097333;
        map[865653] = 64097360;
        map[58517840] = 64097352;
        map[58517249] = 64097356;
        map[58517269] = 64097354;
        map[50939446] = 64097339;
        map[861760] = 64097319;
        map[860983] = 64097345;
        map[861267] = 64097325;
        map[57921281] = 64097341;
        map[72824623] = 72824623;
        map[987397] = 64097329;
        map[2737291] = 64097327;
        map[76704778] = 76704778;
        map[50882819] = 64097331;
        map[75986175] = 75986175;
        map[40538208] = 64097321;
        map[55453759] = 64097343;
        map[13702456] = 64097323;
        map[867648] = 64097362;
        map[860833] = 64097364;
        map[947174] = 64097366;
        map[4669695] = 64097335;
        map[861151] = 64097337;
        map[58528002] = 64097347;
        map[860919] = 64097368;
        map[75431019] = 75431019;

        return map;
    },
    correctDescription(description) {
        if (description.indexOf('Template: ') != -1)
            description = description.replace('Template: ', '');

        return description;
    },
    checkThumbUrl(url) {
        if (!url)
            return undefined;

        var firstIndex = url.indexOf('file/ci/'),
            endIndex = url.indexOf('/thumb'),
            contentItemId;

        if (firstIndex != -1 &&  endIndex!= -1)
            contentItemId = url.substring(firstIndex + 8, endIndex);

        return contentItemId;
    },
    detectLanguage(id) {
        var language = "en_US";

        switch(id) {
            case (1): {
                language = "nb_NO";
                break;
            }

            case (2): {
                language = "en_US";
                break;
            }

            case (3): {
                language = "nn_NO";
                break;
            }

            case (4): {
                language = "fr_FR";
                break;
            }

            case (6): {
                language = "de_DE";
                break;
            }

            case (7): {
                language = "nl_NL";
                break;
            }

            case (8): {
                language = "sv_SE";
                break;
            }

            case (9): {
                language = "da_DK";
                break;
            }

            case (11): {
                language = "fi_FI";
                break;
            }

            case (12): {
                language = "es_ES";
                break;
            }
        }

        return language;
    },
    isLoginWithToken() {
        if (appParameters.token && appParameters.token.length > 0)
            return true;
        else
            return false;
    }
};

export default sessionUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/SessionUtils.js
 **/